// extracted by mini-css-extract-plugin
export default {"wrap":"Onboarding_wrap__NjnAX","wordmark":"Onboarding_wordmark__Vm9GP","spinner":"Onboarding_spinner__8-mt1","spin":"Onboarding_spin__AfSDl"};